import * as log from "loglevel";
import * as marked from "marked";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { Button, Confirm, Form, Modal, Table, TextArea } from "semantic-ui-react";

import { ReleaseNote as ReleaseNoteComponent } from "../../components/release-note";
import { SystemMessage } from "../../stores/models/system-message";
import { SystemMessageStore } from "../../stores/system-message-store";
import { LoadingSpinner } from "../common/loading-spinner";


interface IAdminViewProps {
	systemMessageStore?: SystemMessageStore;
}

interface IAdminViewState {
	systemMessage: SystemMessage;
	systemMessageConfirm: boolean;
}


@inject("systemMessageStore") @observer
export class AddSystemMessage extends React.Component<IAdminViewProps, IAdminViewState>{
	constructor(props, state) {
		super(props, state);
		this.state = {
			"systemMessage": new SystemMessage(),
			"systemMessageConfirm": false
		};
		this.openMessageConfirm = this.openMessageConfirm.bind(this);
		this.closeMessageConfirm = this.closeMessageConfirm.bind(this);
		this.confirmMessageNote = this.confirmMessageNote.bind(this);
	}

	async confirmMessageNote() {
		await this.props.systemMessageStore.addMessage(this.state.systemMessage);
		await this.props.systemMessageStore.loadSystemMessage();
		this.setState({
			"systemMessageConfirm": false,
			"systemMessage": new SystemMessage()
		});
	}

	openMessageConfirm() {
		this.setState({
			"systemMessageConfirm": true
		});
	}

	closeMessageConfirm() {
		this.setState({
			"systemMessageConfirm": false
		});
	}

	showPreview() {
		this.props.systemMessageStore.previewMessage(this.state.systemMessage);
	}

	async deleteMessage(message) {
		await this.props.systemMessageStore.deleteMessage(message);
		await this.props.systemMessageStore.loadSystemMessage();
	}

	render() {
		let disableButtonForSystemMessage = this.state.systemMessage.text === "" || this.state.systemMessage.startDate === "" || this.state.systemMessage.endDate === "";
		return (
			<div>
				<Confirm open={this.state.systemMessageConfirm} onCancel={this.closeMessageConfirm} onConfirm={this.confirmMessageNote}
					content={<div style={{ "padding": "20px" }}>Are you sure you want to push this system message? </div>}
					header="Release confirmation" confirmButton="Yes" cancelButton="No" />
				{this.props.systemMessageStore.loading &&
					<LoadingSpinner text="Loading System Message" />
				}
				<Form onSubmit={this.openMessageConfirm}>
					<Form.Field inline>
						<label>
							System Message Text (This field accepts Markdown, for syntax click <a href="https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet" target="_blank">here</a>).
						</label>
						<TextArea value={this.state.systemMessage.text} onChange={(e, data) => { this.state.systemMessage.updateProperty("text", data.value); }} />
					</Form.Field>
					<Form.Input inline placeholder="01/01/2000" label="Start from (include entered date)" value={this.state.systemMessage.startDate} onChange={(e, data) => { this.state.systemMessage.updateProperty("startDate", data.value); }} />
					<Form.Input inline placeholder="02/01/2000" label="End on (not include entered date)" value={this.state.systemMessage.endDate} onChange={(e, data) => { this.state.systemMessage.updateProperty("endDate", data.value); }} />

					<Button className="jibunu-green" disabled={this.state.systemMessage.text === ""} onClick={() => this.showPreview()} content="Preview" size="small" type="button" />

					<br />
					<br />
					<Button className="jibunu-red" type="submit" content="Add System Message" disabled={disableButtonForSystemMessage} />
				</Form>

				<Table celled>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Text</Table.HeaderCell>
							<Table.HeaderCell>Start Date</Table.HeaderCell>
							<Table.HeaderCell>End Date</Table.HeaderCell>
							<Table.HeaderCell>Action</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{this.props.systemMessageStore.messages.map(message => <Table.Row>
							<Table.Cell>{message.text}</Table.Cell>
							<Table.Cell>{message.startDate}</Table.Cell>
							<Table.Cell>{message.endDate}</Table.Cell>
							<Table.Cell><Button color="red" onClick={() => this.deleteMessage(message)}>Delete</Button></Table.Cell>
						</Table.Row>
						)}
					</Table.Body>
				</Table>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/admin/add-system-message.tsx